<script lang="ts">
import './nr-button.scss'

export const VARIANTS = [
  'filled-primary',
  'filled-neutral',
  'filled-success',
  'filled-danger',
  'filled-white',
  'bordered-primary',
  'bordered-neutral',
  'bordered-success',
  'bordered-danger',
  'minimal-primary',
  'minimal-neutral',
  'minimal-success',
  'minimal-danger'
]

export const SIZES = ['normal', 'small']

export default {
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    variant: {
      type: String,
      default: 'filled-primary'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classNames() {
      return [
        'nr-button',
        `variant--${this.variant}`,
        {
          'size--normal': this.size === 'normal',
          'size--small': this.size === 'small'
        }
      ]
    }
  }
}
</script>

<template>
  <button v-bind="$attrs" :disabled="disabled" :class="classNames">
    <slot></slot>
  </button>
</template>
